import React, { useState } from "react";
import "./ForgotPasswordPage.css";

const ForgotPasswordPage: React.FC = () => {
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const API_URL = process.env.REACT_APP_API_URL;

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setMessage("");
        setError("");

        try {
            // Use relative URL to match your signup flow
            const res = await fetch(`${API_URL}/forgot-password`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email }),
            });           

            const data = await res.json();

            if (res.ok) {
                setMessage(data.message); // show success message
                setEmail("");             // clear input
            } else {
                setError(data.message || "Something went wrong"); // show error from server
            }
        } catch (err) {
            console.error(err);
            setError("Network error");
        }
    };

    return (
        <div className="forgot-password-page">
            <div className="forgot-password-wrapper">
                <img src={`${process.env.PUBLIC_URL}/eda_forgot_password.png`} alt="Logo" className="forgot-password-logo" />
                <h2 className="reset-heading">Forgot Password</h2>
                <form onSubmit={handleSubmit} className="forgot-password-form">
                    <input
                        type="email"
                        placeholder="Enter your email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                    <button type="submit">Get Password</button>
                    {message && <p className="login-success">{message}</p>}
                    {error && <p className="login-error">{error}</p>}
                </form>
            </div>
        </div>
    );
};

export default ForgotPasswordPage;
